import { TopNav, PageShell, BackCoverFooter, BrutalistBadge } from "@/app/components/brand-scaffold";
import { siteHeaderActions, siteNavItems } from "@/app/content";

export default function MarketplaceRoadmapPage() {
  return (
    <PageShell>
      <TopNav navItems={siteNavItems} actionItems={siteHeaderActions} homeHref="/" />
      <main className="relative z-10 w-full overflow-hidden px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="mx-auto max-w-4xl">
          <div className="mb-8">
            <BrutalistBadge bgClass="bg-[#14B8A6]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white" className="text-white">
              ROADMAP
            </BrutalistBadge>
          </div>
          <h1 className="text-4xl sm:text-5xl font-black text-black mb-4">
            Marketplace 路线图
          </h1>
          <p className="text-lg font-bold text-zinc-600 mb-8">
            从 Preview catalog 到公开发布的演进路径。
          </p>
          <div className="border-4 border-black bg-[#FACC15]/20 p-4 mb-12 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
            <p className="text-sm font-bold text-zinc-800">
              ⚠️ 以下时间线和指标均为目标规划，不代表承诺。实际进度取决于协议稳定性和早期用户反馈。
            </p>
          </div>

          <div className="space-y-8">
            {roadmapPhases.map((phase) => (
              <div key={phase.title} className={`border-4 border-black p-6 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] ${phase.bg}`}>
                <div className="flex items-center gap-3 mb-3">
                  <span className={`px-2 py-0.5 text-[10px] font-black uppercase ${phase.statusBg}`}>{phase.status}</span>
                  <h2 className="text-xl font-black">{phase.title}</h2>
                </div>
                <p className="text-sm text-zinc-700 mb-3">{phase.desc}</p>
                <ul className="space-y-1">
                  {phase.items.map((item) => (
                    <li key={item} className="text-sm text-zinc-600">• {item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 border-l-8 border-black pl-5">
            <p className="text-base font-bold text-zinc-800">
              以上所有 mock 数据和指标目标均为说明用途。真实运营数据将在公开发布后展示。
            </p>
          </div>
        </div>
      </main>
      <BackCoverFooter />
    </PageShell>
  );
}

const roadmapPhases = [
  {
    title: "Phase 0 · Preview Catalog",
    status: "当前",
    statusBg: "bg-[#A3E635] text-black",
    bg: "bg-[#A3E635]/10",
    desc: "展示示例 Hotline，验证 contract 结构和发现机制。",
    items: [
      "示例 Hotline 展示 catalog 结构",
      "Contract 字段完整性验证",
      "Responder 视图和版本管理 UI",
      "无真实调用、无结算、无评分",
    ],
  },
  {
    title: "Phase 1 · Closed Beta",
    status: "规划中",
    statusBg: "bg-[#FACC15] text-black",
    bg: "bg-white/85",
    desc: "邀请制开放首批 Responder 上架真实 Hotline。",
    items: [
      "审核流程上线",
      "真实调用链路打通",
      "Call Credit 内部计量",
      "首批真实 result_package 数据",
    ],
  },
  {
    title: "Phase 2 · Public Publishing",
    status: "远期",
    statusBg: "bg-white/80 text-black border border-black",
    bg: "bg-white/85",
    desc: "开放公开发布，任何通过审核的 Responder 可上架。",
    items: [
      "公开注册和审核",
      "评分和调用历史公开",
      "搜索和分类发现",
      "Caller 自助接入",
    ],
  },
  {
    title: "Phase 3 · Settlement Network",
    status: "远期",
    statusBg: "bg-white/50 text-black/70 border border-black/30",
    bg: "bg-white/85",
    desc: "法币结算和提现能力上线。",
    items: [
      "法币充值和提现",
      "自动结算和对账",
      "Responder 收入仪表盘",
      "税务和合规接入",
    ],
  },
];
